export default __webpack_public_path__ + "locales/az/PaymentsEnterprise.json?hash=0f749c6d3898703688480ad41f02d20b";